import dayjs from 'dayjs';

const getTimeDifferenceInMilliseconds = (endDate?: string | null) => dayjs(endDate || 0).valueOf() - dayjs().valueOf();

export default getTimeDifferenceInMilliseconds;
